import * as React from 'react';

import { DegreePlan_LearnerProgressState as LearnerProgressState } from '__generated__/graphql-types';

import type { UseCurriculum_EstimatedAcademicTermFragment as EstimatedAcademicTerm } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';
import { MetadataTypography } from 'bundles/program-loggedin-shared/components/Metadata';

import _t from 'i18n!nls/degree-home';

const MAX_TERM_COUNT = 3;

const pickMaxTerms = (terms: EstimatedAcademicTerm[]): EstimatedAcademicTerm[] => terms.slice(0, MAX_TERM_COUNT);

const stringifyTerms = (terms: EstimatedAcademicTerm[]): string =>
  terms.map((term) => term.estimatedTermName).join(', ');

/**
 * Render the list of terms
 * @private
 */
export const termsStringifier = (terms: EstimatedAcademicTerm[]): string => {
  const firstNTerms = pickMaxTerms(terms);
  const termString = stringifyTerms(firstNTerms);

  const showAndMoreText = terms.length > MAX_TERM_COUNT;

  if (showAndMoreText) {
    return _t('Offered in: #{termString} and more', { termString });
  }

  return _t('Offered in: #{termString}', { termString });
};

const EstimatedTermsOfferedIn: React.VFC<{
  termAvailability: EstimatedAcademicTerm[] | null | undefined;
  state: LearnerProgressState;
}> = ({ termAvailability, state }) => {
  if (!termAvailability) {
    return null;
  }

  const learnerHasStartedCourse = state !== LearnerProgressState.NotStarted;
  const noTermsToRender = termAvailability.length === 0;

  if (learnerHasStartedCourse || noTermsToRender) {
    return null;
  }
  return <MetadataTypography>{termsStringifier(termAvailability)}</MetadataTypography>;
};

export default EstimatedTermsOfferedIn;
